import { render, staticRenderFns } from "./RefsVehicle.vue?vue&type=template&id=70861fbe"
import script from "./RefsVehicle.vue?vue&type=script&lang=ts"
export * from "./RefsVehicle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports